<script>
  import { domainName, record } from '../stores.js';

  // const mechanisms = [].concat.apply([], $record.mechanisms);

  function flatten(i, arrayField){
    if (Array.isArray(i)) return i.map(c => flatten(c, arrayField));
    if (i.hasOwnProperty(arrayField)) return [{...i,[arrayField]:null}, ...i[arrayField].map(c => flatten(c, arrayField))];
    return {...i, [arrayField]:null};
  }

  let mechanisms = flatten($record.mechanisms, 'nested_record');
  mechanisms = [].concat(...mechanisms);
  // console.log(mechanisms);

</script>

<div class="record-box record-tags">
  <div id="headingRaw" class="box-label">
    <h5>Discovered Tags</h5>
    <p>The tags and their definitions pulled from the record for {$domainName}</p>
    <button type="button" class="btn-collapse collapsed" data-toggle="collapse" data-target="#collapseTags" aria-expanded="false" aria-controls="collapseTags" aria-label="Close"></button>
  </div>
  <div id="collapseTags" class="box-detail collapse" aria-labelledby="headingRaw">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Mechanism / Modifier</th>
          <th>Content</th>
          <th>Number of IP Addresses Authorized</th>
          <th>Explanation</th>
        </tr>
      </thead>
      <tbody>
        {#each mechanisms as mechanism }
          <tr>
            <td>{mechanism.mechanism ?? ''}</td>
            <td>{mechanism.content ?? ''}</td>
            <td>{mechanism.authorized_ips ?? ''}</td>
            <td>{mechanism.description ?? ''}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>

<style>
th:first-child {
  width: 18.3%;
}
th:nth-child(2) {
  width: 23.3%;
}
th:nth-child(2),
tbody tr td:nth-child(2) {
  background: #f7f9fb;
}
th:last-child {
  width: 30.3%;
}
</style>
